export function optimizeImg(url, w = 480) {
  if (!url || typeof url !== "string") return url;
  try {
    if (url.includes("images.unsplash.com")) {
      const u = new URL(url);
      u.searchParams.set("w", String(w));
      u.searchParams.set("q", "60");
      u.searchParams.set("auto", "format");
      u.searchParams.set("fit", "crop");
      return u.toString();
    }
    if (url.includes("images.pexels.com")) {
      const u = new URL(url);
      u.searchParams.set("auto", "compress");
      u.searchParams.set("cs", "tinysrgb");
      u.searchParams.set("w", String(w));
      return u.toString();
    }
  } catch {
    return url;
  }
  return url;
}
